<!-- todo Check with activeSubItem // and maybe create a ng-template ? and handle scrollTrigger for subItems -->
@let config = resolvedConfig();
@if (activeMenu()) {
  <div
    class="sticky-tab-list fixed left-0 top-0 z-120 block h-screen w-screen overflow-x-auto bg-white py-3 pr-4 scrollbar-hide"
    [class.pt-10]="isNotched()"
    [class.shadow-none]="isNotched()"
    [class.border-b]="isNotched()"
    [ngClass]="{
      'block bg-white fixed top-0 left-0 z-120 h-screen w-screen py-3': activeMenu(),
      'px-3 lg:px-12': !config.display_burger_navigation && config.padding_x,
      'lg:pr-12': config.display_burger_navigation && config.padding_x,
    }"
    [style.backgroundColor]="config.categories_background_color | contentBuilderColor: '#FFFFFF'"
    #scrollSection
  >
    @if (activeMenu() || search()) {
      <div
        class="w-full text-left"
        [ngClass]="{
          'px-3 lg:px-12': activeMenu() && config.padding_x,
        }"
      >
        @if (activeMenu()) {
          <app-rounded-icon-button
            class="mr-4"
            [outlined]="true"
            [icon]="'icon-cross font-bold'"
            [size]="'sm'"
            [fontSize]="'text-xs'"
            [overrideBackgroundColor]="config.burger_background_color"
            [overrideColor]="config.burger_icon_color"
            (click)="toggleMenu()"
          ></app-rounded-icon-button>
        }
        @if (search()) {
          <app-rounded-icon-button
            class="mr-4"
            [outlined]="true"
            [icon]="'icon-zoom font-bold'"
            [size]="'sm'"
            [fontSize]="'text-base'"
            [overrideBackgroundColor]="config.burger_background_color"
            [overrideColor]="config.burger_icon_color"
            (click)="toggleSearch()"
          ></app-rounded-icon-button>
        }
      </div>
    }
    <ng-container
      *ngTemplateOutlet="tabMenuSection; context: { data: typedTplDataEntry(treeTabsUI(), 0) }"
    />
  </div>
}
<ng-container
  *ngTemplateOutlet="tabSection; context: { data: typedTplDataEntry(treeTabsUI(), 0) }"
/>

<ng-template
  #tabSection
  let-unTypedTplData="data"
>
  @let treeTabsSection = typedTplData(unTypedTplData);
  @let sectionColors = categoriesColorsByLevel()[treeTabsSection.level];

  <div
    class="shadow-xs mx-auto flex items-center justify-center text-center shadow"
    [style.backgroundColor]="sectionColors.backgroundColor | contentBuilderColor: '#FFFFFF'"
  >
    @if (treeTabsSection.level === 0) {
      <div #btnMenu>
        @if (!activeMenu() && config.display_burger_navigation) {
          <app-rounded-icon-button
            class="px-5 lg:pl-12"
            [outlined]="true"
            [icon]="'icon-hamburger font-bold'"
            [size]="'sm'"
            [fontSize]="'text-xs'"
            [overrideBackgroundColor]="config.burger_background_color"
            [overrideColor]="config.burger_icon_color"
            (click)="toggleMenu()"
          ></app-rounded-icon-button>
        }
      </div>
    }

    @let activeTab = treeTabsSection.data | appFn: getActiveTab;
    <div
      appHorizontalScroll
      [appScrollToId]="activeTab ? 'tabList-' + activeTab.id : ''"
      class="sticky-tab-list flex w-full items-center overflow-x-auto pr-4 scrollbar-hide"
      [class.pt-10]="isNotched()"
      [class.shadow-none]="isNotched()"
      [style.backgroundColor]="sectionColors.backgroundColor | contentBuilderColor: '#FFFFFF'"
      [class.border-b]="isNotched()"
      [ngClass]="{
        'px-3 lg:px-12': !config.display_burger_navigation && config.padding_x,
        'lg:pr-12': config.display_burger_navigation && config.padding_x,
      }"
      [class.pl-5]="treeTabsSection.level > 0"
      #scrollSection
    >
      <div class="flex items-center">
        @for (treeTab of treeTabsSection.data; track $index) {
          <button
            [id]="'tabList-' + treeTab.id"
            [class]="
              treeTabsSection.level >= 1
                ? 'relative mr-3 flex items-center whitespace-nowrap border-b18 px-2 py-2 font-accent kiosk:text-2xl lg:py-2'
                : 'relative mr-3 flex items-center whitespace-nowrap border-b-4 px-2 py-3 font-accent font-semibold kiosk:text-2xl lg:py-5'
            "
            [class.scroll-target-item]="treeTab.isActive && treeTabsSection.level === 0"
            [style.borderColor]="
              treeTab.isActive ? (sectionColors.activeColor | contentBuilderColor) : 'transparent'
            "
            [style.color]="
              treeTab.isActive
                ? (sectionColors.activeColor | contentBuilderColor)
                : (sectionColors.inactiveColor | contentBuilderColor)
            "
            (click)="tabClick(treeTab.id)"
          >
            {{ treeTab.name }}
            @if (treeTab.icon) {
              <span class="text-8px transform rotate-180 icon icon-{{ treeTab.icon }} ml-2"></span>
            }
          </button>
        }
      </div>
    </div>
  </div>
  <!-- IF the selected tab has children -> display another tab section -->
  @if (activeTab?.children && activeTab.children.length > 0) {
    <ng-container
      *ngTemplateOutlet="
        tabSection;
        context: { data: typedTplDataEntry(activeTab.children, treeTabsSection.level + 1) }
      "
    />
  }
</ng-template>

<ng-template
  #tabMenuSection
  let-unTypedTplData="data"
>
  @let treeTabsSection = typedTplData(unTypedTplData);
  @let sectionColors = categoriesColorsByLevel()[treeTabsSection.level];

  <div class="py-2 pl-4"></div>
  @for (treeTab of treeTabsSection.data; track $index) {
    <div class="mb-2">
      <button
        class="flex w-full items-center rounded-lg px-3 py-2 text-left font-accent kiosk:text-2xl transition-colors duration-200"
        [style.color]="sectionColors.activeColor | contentBuilderColor"
        (click)="tabClick(treeTab.id)"
      >
        <span>{{ treeTab.name }}</span>
        @if (treeTab.children && treeTab.children.length > 0) {
          <span class="ml-auto rotate-90 transform text-xs">
            <span class="icon icon-chevron-right"></span>
          </span>
        }
      </button>

      <!-- Recursive children -->
      @if (treeTab.children && treeTab.children.length > 0) {
        <div
          class="border-l-1 ml-2 mt-1 pl-2"
          [style.borderColor]="sectionColors.activeColor | contentBuilderColor"
        >
          <ng-container
            *ngTemplateOutlet="
              tabMenuSection;
              context: {
                data: typedTplDataEntry($any(treeTab.children), treeTabsSection.level + 1),
              }
            "
          />
        </div>
      }
    </div>
  }
</ng-template>
